import React from 'react';
import { AppState, Booking, SharingType } from 'acscp/store';
import { FormattedMessage } from 'react-intl';
import { Redirect } from 'react-router';
import { SharingPage } from '../sharing/sharingPage';
import { closeModalByGoingBackIfPossibleFallingBackToUrl, Modal } from '../common/modal';
import { PresentationComponentBase } from '../presentationComponentBase';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';
import { connect } from 'react-redux';
import { LoginRequiredModal } from '../auth/loginRequiredModal';

interface SharingModalOwnProps {
    booking: Booking;
}

interface SharingModalStateProps {
    isLoggedIn: boolean;
}

class SharingModalPresentational
        extends PresentationComponentBase<SharingModalOwnProps, SharingModalStateProps, {}, {}> {

    getSharingType(): SharingType[] {
        switch (this.props.booking.status) {
            case 'ItineraryAvailable':
                return [SharingType.Itinerary];
            case 'AwaitingQuotes':
            case 'QuotesAvailable':
            case 'FlightPlanning':
            case 'CheckingAvailability':
                return [SharingType.Quote, SharingType.Itinerary];
            default:
                return [];
        }
    }

    render(): JSX.Element {
        const sharingTypes = this.getSharingType();
        if (sharingTypes.length === 0) {
            return <Redirect to={'/trip/' + this.props.booking.id} />;
        }

        if (!this.props.isLoggedIn) {
            return <LoginRequiredModal closeUrl={'/trip/' + this.props.booking.id} />;
        }

        return (
            <Modal
                modalHeaderContent={
                    <FormattedMessage id={'components.sharing.sharingModal.modalHeader'} defaultMessage={'SHARE'} />}
                isOpen={true}
                closeModal={
                    closeModalByGoingBackIfPossibleFallingBackToUrl('/trip/' + this.props.booking.id)
                }
            >
                <SharingPage booking={this.props.booking} sharingTypes={sharingTypes} />
            </Modal>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: SharingModalOwnProps): SharingModalStateProps {
    return {
        isLoggedIn: userIsLoggedIn(state.auth)
    };
}

export const SharingModal = connect(mapStateToProps)(SharingModalPresentational);
